import { CommonModule } from '@angular/common';
import { Component, Input, OnInit } from '@angular/core';
import { TranslocoPipe } from '@jsverse/transloco';
import { FileManagementService } from '../../../../core/api/file-management.service';
import { ApiErrorService } from '../../../../core/api/api-error.service';
import { AdminFileGet, AdminFileType } from '../../../../core/interfaces/file-management-interfaces';
import { ToastComponent } from '../../../../shared/components/toast/toast.component';
import { HttpErrorResponse } from '@angular/common/http';
import { lastValueFrom } from 'rxjs';
import { AdminFileManagementUploadComponent } from "../admin-file-management-upload/admin-file-management-upload.component";
import { IsoToFormattedDateTimePipe } from "../../../../core/pipes/iso-to-formatted-date-time.pipe";

@Component({
  selector: 'app-admin-electricity-and-gas-prices',
  standalone: true,
  imports: [CommonModule, TranslocoPipe, AdminFileManagementUploadComponent, IsoToFormattedDateTimePipe],
  templateUrl: './admin-electricity-and-gas-prices.component.html',
  styleUrl: './admin-electricity-and-gas-prices.component.css'
})
export class AdminElectricityAndGasPricesComponent implements OnInit {
  constructor(private fileManagement: FileManagementService, private apiError: ApiErrorService) { }
  AdminFileType = AdminFileType;
  @Input() toast?: ToastComponent;

  elAndGasPrices: AdminFileGet[] = [];

  ngOnInit(): void {
    this.loadElectricityAndGasPrices();
  }

  loadElectricityAndGasPrices() {
    this.fileManagement.getElectricityAndGasPrices().subscribe({
      next: (response) => {
        if (response) {
          this.elAndGasPrices = [];
          this.elAndGasPrices = response;
        }
      },
      error: async (error) => {
        var crid = 'UNKNOWN-CRID';

        if (error instanceof HttpErrorResponse) {
          crid = error.headers?.get('x-correlation-id') || 'UNKNOWN-CRID';
        }
        this.toast?.showToast(await this.apiError.getErrorHeader(), await this.apiError.getErrorMessage(crid), 'error', 8000, false);
      },
      complete: () => {
      }
    });
  }

  async getFileManagementFileUrl(fileId: string) {
    try {
      var response = await lastValueFrom(this.fileManagement.downloadFile(fileId));
      return response.download_url;

    } catch (error) {
      var crid = 'UNKNOWN-CRID';

      if (error instanceof HttpErrorResponse) {
        crid = error.headers?.get('x-correlation-id') || 'UNKNOWN-CRID';
      }
      this.toast?.showToast(await this.apiError.getErrorHeader(), await this.apiError.getErrorMessage(crid), 'error', 8000, false);
    }
    return null;
  }

  async downloadFile(fileId: string) {
    const fileUrl = await this.getFileManagementFileUrl(fileId || '');
    if (fileUrl) {
      window.open(fileUrl, '_blank');
    }
  }
}
